import $ from 'jquery';

// Открытие модального окна для отклонения отзыва
$(".reject__modal-toggle").on('click', function() {
    $(".reject__review").data("id", $(this).data("id"));
});

// Функция смены статуса отзыва (публикация/отклонение)
function changeReviewStatus() {
    const reviewId = $(this).data("id");
    const _token = $("input[name='_token']").val();
    const comment = $("#comment");

    const formData = new FormData();
    formData.append("status", $(this).data("status"));
    formData.append("_method", "PATCH");
    formData.append("_token", _token);
    if (comment.length) {
        formData.append("comment", comment.val());
    }

    fetch(`/review/${reviewId}`, {
        method: "POST",
        body: formData,
    }).then(() => {
        location.reload();
        if (comment.length) {
            comment.val('');
        }
    });
}

// Клик по кнопке публикации отзыва
$(".publicate__review").on("click", changeReviewStatus);

// Клик по кнопке отклонения отзыва
$(".reject__review").on("click", changeReviewStatus);